"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _avatar = require("../avatar");
var _constants = require("./constants");
var _ContactCardAvatarWrap = require("./styled/ContactCardAvatarWrap");
var _ContactCardBody = require("./styled/ContactCardBody");
var _ContactCardRoot = require("./styled/ContactCardRoot");
var _ContactCardWrapper = require("./styled/ContactCardWrapper");
const ContactCard = _ref => {
  let {
    avatarProps,
    children,
    cardHeader,
    className,
    clientId,
    mode = "normal",
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (mode === "condensed" && _react.default.Children.toArray(children).length > 2) {
      console.warn("The condensed version is intended for use in lists and should not have more than two children (e.g. name and email)");
    }
  }
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const contactCardRootClassName = (0, _classnames.default)(className, {
    [_constants.CONTACT_CARD_WITH_HEADER_CLASSNAME]: !!cardHeader
  });
  return /*#__PURE__*/_react.default.createElement(_ContactCardRoot.ContactCardRoot, (0, _extends2.default)({}, rest, {
    className: contactCardRootClassName,
    "data-client-id": clientId,
    mode: mode,
    role: "group",
    themeMode: themeMode
  }), cardHeader, /*#__PURE__*/_react.default.createElement(_ContactCardWrapper.ContactCardWrapper, null, /*#__PURE__*/_react.default.createElement(_ContactCardAvatarWrap.ContactCardAvatarWrap, {
    mode: mode
  }, /*#__PURE__*/_react.default.createElement(_avatar.Avatar, (0, _extends2.default)({}, avatarProps, {
    size: mode === "normal" ? "large" : "medium",
    "aria-hidden": true,
    tabIndex: -1
  }))), /*#__PURE__*/_react.default.createElement(_ContactCardBody.ContactCardBody, null, children)));
};
exports.ContactCard = ContactCard;
//# sourceMappingURL=ContactCard.js.map